module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-5-bfa03de67a8c24441b7e102dffcc1c9e.png";